/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindRelatedProductionSitesByOrganizationIdQueryResponse,
  FindRelatedProductionSitesByOrganizationIdQueryParams,
} from "../types/FindRelatedProductionSitesByOrganizationId.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findRelatedProductionSitesByOrganizationIdQueryKey = (
  params: FindRelatedProductionSitesByOrganizationIdQueryParams
) =>
  [
    {
      url: "/v1/production-site/find-related-production-sites-by-organization-id",
    },
    ...(params ? [params] : []),
  ] as const

export type FindRelatedProductionSitesByOrganizationIdQueryKey = ReturnType<
  typeof findRelatedProductionSitesByOrganizationIdQueryKey
>

/**
 * @summary Find related production sites by requester organization id
 * {@link /v1/production-site/find-related-production-sites-by-organization-id}
 */
export async function findRelatedProductionSitesByOrganizationId(
  params: FindRelatedProductionSitesByOrganizationIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindRelatedProductionSitesByOrganizationIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/production-site/find-related-production-sites-by-organization-id`,
    params,
    ...requestConfig,
  })
  return res
}

export function findRelatedProductionSitesByOrganizationIdQueryOptions(
  params: FindRelatedProductionSitesByOrganizationIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findRelatedProductionSitesByOrganizationIdQueryKey(params)
  return queryOptions<
    ResponseConfig<FindRelatedProductionSitesByOrganizationIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindRelatedProductionSitesByOrganizationIdQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findRelatedProductionSitesByOrganizationId(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find related production sites by requester organization id
 * {@link /v1/production-site/find-related-production-sites-by-organization-id}
 */
export function useFindRelatedProductionSitesByOrganizationId<
  TData =
    ResponseConfig<FindRelatedProductionSitesByOrganizationIdQueryResponse>,
  TQueryData =
    ResponseConfig<FindRelatedProductionSitesByOrganizationIdQueryResponse>,
  TQueryKey extends QueryKey =
    FindRelatedProductionSitesByOrganizationIdQueryKey,
>(
  params: FindRelatedProductionSitesByOrganizationIdQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindRelatedProductionSitesByOrganizationIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findRelatedProductionSitesByOrganizationIdQueryKey(params)

  const query = useQuery(
    {
      ...findRelatedProductionSitesByOrganizationIdQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
